import { useState, useEffect, useCallback } from 'react'
import * as R from 'ramda'

const isFormPristine = (formRef, equals = R.equals) =>
  R.compose(
    ([pristineValues, currentValues]) => equals(pristineValues, currentValues),
    R.ifElse(R.isNil, R.always([]), (form) => [
      form.getPristineValues(),
      form.getCurrentValues(),
    ]),
    R.prop('current'),
  )(formRef)

export const useFormsy = (formRef, equals) => {
  const [isPristine, setIsPristine] = useState(false)

  const equalsCallback = useCallback(equals, [])

  const reset = () => {
    setIsPristine(isFormPristine(formRef, equalsCallback))
  }

  const handleChange = useCallback(() => {
    setIsPristine(isFormPristine(formRef, equalsCallback))
  }, [formRef, equalsCallback])

  useEffect(() => {
    setIsPristine(isFormPristine(formRef, equalsCallback))
  }, [formRef, equalsCallback])
  return { isPristine, onChange: handleChange, reset }
}

export function removeDoNotTranslateStyle(html) {
  if (!html) return html
  return R.replace(
    /<span.*?(translate="no"|class="notranslate").*?>/g,
    (match) => {
      return R.compose(
        R.replace(
          /border-radius: 2px;|padding: 2px 0px;|background-color: rgb\(211, 238, 240\);/g,
          '',
        ),
        R.replace(/translate="no"/, 'class="notranslate" translate="no"'),
      )(match)
    },
    html,
  )
}
